<template>
    <span v-if="collaIdx==null" class="text-red-600 hover:text-red-400 hover:underline w-fit inline-flex items-baseline">[!] Colla no trobada ({{ colla }})</span>
    <router-link v-else :to="collaRuta" class="text-red-600 hover:text-red-400 hover:underline inline-flex items-baseline">
        <div :style="{backgroundColor:collaIdx.codi_color}" class="aspect-square h-4 border-solid border border-1 mr-0.5 self-center"></div>
        {{ textAlt() }}
        <IcoTipEst v-if="icones==true" :colla="collaIdx" dada="tipus" class="ml-1"/>
        <IcoTipEst v-if="icones==true" :colla="collaIdx" dada="estat" class="ml-1"/>
        
        <tippy to="parent" content-tag="div" content-class="w-fit"> 
                <TargetaInfo :colla="collaIdx"/>
        </tippy>
    </router-link>
</template>

<script>
import {computed, inject} from 'vue'
import IcoTipEst from './IcoTipEst.vue';
import TargetaInfo from './TargetaInfo.vue';
import altresColles from '@/json/altres_colles.json';

export default({
    components:{
        IcoTipEst,
        TargetaInfo
    },
    props:{
        colla:{
            type:String,
            required:true
        },
        text:{
            type:String,
            required:false
        },
        icones:{
            type:Boolean,
            required:false,
            default:false
        }
    },
    setup(props) {
        const dades = inject('dades', [])
        const collaIdx = computed(() => {
            return dades.find(c => c.id === props.colla) || altresColles.find(c => c.id === props.colla) || null
        })

        const collaRuta = computed(() => {
            if (!collaIdx.value) return null
            return collaIdx.value.llista === 'altres' ? `/altres/${collaIdx.value.id}` : `/colles/${collaIdx.value.id}`
        })

        function textAlt(){
            if (props.text==null){
                return collaIdx.value?.nom ?? props.colla
            }
            else{
                return props.text
            }
        }
        return{
            textAlt,
            collaIdx,
            collaRuta
        }
    },
})
</script>
